/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { Component, PropTypes } from 'react';
import { Row, Input, Label, Button, Col, Modal, ModalHeader, Container, ModalFooter } from 'src/components/Common/reactstrap/lib';

class ModalCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: props.company || {type: {legalTypeId: 3}}
    };
    this.submit = this.submit.bind(this);
    this.changeInputValue = this.changeInputValue.bind(this);
    this.renderRowWithKPPInput = this.renderRowWithKPPInput.bind(this);
  }


  submit() {
    const checkForNull = (obj) => {
      const {bik, inn, kpp, legalAddress, name, paymentAccount, type} = obj;

      if(!type.legalTypeId)
        return false;

      let result = (!!kpp || +type.legalTypeId === 1) && !!inn && !!legalAddress && !!name;

      return result;
    };


    const company = this.state.company;
    const isDataValid = checkForNull(company) && !!company.type.legalTypeId;

    if(isDataValid) {
      this.props.addOrUpdateLegals([company]);
      this.props.close();
    }
  }

  parseNumeric(value, count){
    return count ? value.replace(/\D/g,'').substring(0, +count) : value.replace(/\D/g,'');
  }

  changeInputValue(value) {

    if(!this.state.company.type && !value.type) {
      this.setState({
        company: {
          ...this.state.company,
          ...value,
          ...{type: {legalTypeId: 3}}
        }
      });
    }
    else {
      this.setState({
        company: {
          ...this.state.company,
          ...value }
      });
    }
  }

  renderOptions() {
    const legalType = this.state.company.type;
    const legalId = legalType ? legalType.legalTypeId : 3;
    const legalTypes = this.props.legalTypes;

    return legalTypes ? legalTypes.map((type) => {
      return (
        <option key={`legal-type-${type.LegalTypeId}`}
          value={type.LegalTypeId}
          selected={legalId == type.LegalTypeId}>
          {type.LegalTypeName}
        </option>
      );
    }) : null;
  }

  renderRowWithKPPInput() {
    const company = this.state.company;
    if(company.type && +company.type.legalTypeId === 1)
      return (
        <Row>
          <Label for="date" sm={1}>Р/C</Label>
          <Col sm={6}>
            <Input
              value={company.paymentAccount || ''}
              onChange={(e) => this.changeInputValue({paymentAccount: this.parseNumeric(e.target.value, 20)})}/>
          </Col>
        </Row>
      );

    return (
      <Row>
        <Label for="date" sm={1}>{company.type && company.type.legalTypeId === 1 ? "" : "КПП"}</Label>
        <Col sm={4}>
          <Input value={company.kpp || ''} onChange={(e) => this.changeInputValue({kpp: this.parseNumeric(e.target.value, 9)})}/>
        </Col>
        <Label for="date" sm={1}>Р/C</Label>
        <Col sm={6}>
          <Input
            value={company.paymentAccount || ''}
            onChange={(e) => this.changeInputValue({paymentAccount: this.parseNumeric(e.target.value, 20)})}/>
        </Col>
      </Row>
    );
  }

  render() {
    let {company} = this.state;
    if (!company) return (<div></div>);
    return (
      <Modal isOpen={this.props.visible} toggle={this.props.close} className={this.props.className}>
        <ModalHeader toggle={this.props.close}>Добавить компанию</ModalHeader>
          <Container>
            <Row>
              <Col sm={3}>
                <Input type="select" name="select" id="exampleSelect"
                  onChange={(e) => this.changeInputValue({type: {legalTypeId: e.target.value}})}>
                  { this.renderOptions() }
                </Input>
              </Col>
              <Col sm={9}>
                <Input type="text"
                  placeholder="Название компании"
                  value={company.name || ''}
                  onChange={(e) => this.changeInputValue({name: e.target.value})}/>
              </Col>
            </Row>
            <Row>
              <Label for="date" sm={1}>ИНН</Label>
              <Col sm={4}>
                <Input value={company.inn || ''} onChange={(e) => this.changeInputValue({inn: this.parseNumeric(e.target.value, 12)})}/>
              </Col>
              <Label for="date" sm={1}>БИК</Label>
              <Col sm={4}>
                <Input value={company.bik || ''} onChange={(e) => this.changeInputValue({bik: this.parseNumeric(e.target.value, 9)})}/>
              </Col>
            </Row>
            {this.renderRowWithKPPInput()}
            <Row>
              <Col sm={12}>
                <Input value={company.legalAddress || ''} placeholder="Юр. адрес" onChange={(e) => this.changeInputValue({legalAddress: e.target.value})}/>
              </Col>
            </Row>
          </Container>

          <ModalFooter>
            <Button onClick={this.submit}>Сохранить</Button>
          </ModalFooter>
        </Modal>
    );
  }
}

ModalCompany.propTypes = {
  isOpen:  PropTypes.bool,

  toggle:  PropTypes.func,

  size: PropTypes.string,

  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  keyboard: PropTypes.bool,

  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default ModalCompany;



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/ModalCompany.jsx
 **/